var Slideshow = require('../../lib/slideshow.js');

module.exports = function() {
    var slideshow = new Slideshow;

    slideshow.setup('.slideshow-container');
};
